// SEO utility functions for Ceremonzy

export const generatePageTitle = (title, includeAppName = true) => {
  const appName = "Ceremonzy";
  if (!title) return `${appName} - Premium Wedding Vendor Platform`;
  if (includeAppName && !title.includes(appName)) {
    return `${title} | ${appName}`;
  }
  return title;
};

export const generateMetaDescription = (description, defaultDescription = null) => {
  const defaultDesc = defaultDescription || "Ceremonzy is India's leading wedding vendor platform. Discover and book premium wedding vendors, photographers, caterers, decorators, and more for your perfect ceremony.";
  return description || defaultDesc;
};

export const generateCanonicalUrl = (path = '/') => {
  const baseUrl = 'https://ceremonzy.com';
  // Ensure path starts with /
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  // Remove trailing slash except for root
  const finalPath = cleanPath === '/' ? '/' : cleanPath.replace(/\/$/, '');
  return `${baseUrl}${finalPath}`;
};

export const generateBreadcrumbs = (path, customLabels = {}) => {
  const baseUrl = 'https://ceremonzy.com';
  const pathSegments = path.split('/').filter(segment => segment);
  
  const breadcrumbs = [
    {
      "@type": "ListItem",
      "position": 1,
      "name": "Home",
      "item": baseUrl
    }
  ];

  let currentPath = '';
  pathSegments.forEach((segment, index) => {
    currentPath += `/${segment}`;
    const label = customLabels[segment] || segment.replace(/-/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    
    breadcrumbs.push({
      "@type": "ListItem",
      "position": index + 2,
      "name": label,
      "item": `${baseUrl}${currentPath}`
    });
  });

  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbs
  };
};

export const generateOrganizationSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "Ceremonzy",
    "url": "https://ceremonzy.com",
    "logo": "https://ceremonzy.com/images/ceremonzy-logo.png",
    "description": "Premium wedding vendor platform helping couples find perfect vendors for their ceremonies",
    "sameAs": [
      "https://facebook.com/ceremonzy",
      "https://instagram.com/ceremonzy",
      "https://twitter.com/ceremonzy"
    ],
    "contactPoint": {
      "@type": "ContactPoint",
      "telephone": "+91-XXXXXXXXXX",
      "contactType": "Customer Service",
      "availableLanguage": ["English", "Hindi"]
    },
    "address": {
      "@type": "PostalAddress",
      "addressCountry": "IN",
      "addressRegion": "Maharashtra"
    }
  };
};

export const generateWebSiteSchema = () => {
  return {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "name": "Ceremonzy",
    "url": "https://ceremonzy.com",
    "description": "Premium wedding vendor platform",
    "potentialAction": {
      "@type": "SearchAction",
      "target": "https://ceremonzy.com/vendors?search={search_term_string}",
      "query-input": "required name=search_term_string"
    },
    "publisher": {
      "@type": "Organization",
      "name": "Ceremonzy",
      "url": "https://ceremonzy.com"
    }
  };
};

export const categoryLabels = {
  'photographers': 'Wedding Photographers',
  'wedding-venues': 'Wedding Venues',
  'catering-services': 'Catering Services', 
  'decorators': 'Wedding Decorators',
  'mehendi-artists': 'Mehendi Artists',
  'dj-music': 'DJ & Music',
  'makeup-artists': 'Makeup Artists',
  'transportation': 'Transportation Services'
};

export const generatePageKeywords = (baseKeywords, additionalKeywords = []) => {
  const defaultKeywords = [
    'Ceremonzy',
    'wedding vendors',
    'wedding planning',
    'Indian weddings',
    'ceremony vendors',
    'wedding services',
    'marriage planning'
  ];
  
  return [...defaultKeywords, ...baseKeywords, ...additionalKeywords].join(', ');
};